export const lgbtq: [number, number][] = [
  [-9.083283933952671, 0.11537237452037274],
  [-8.483283552482945, -1.484626099600721],
  [-10.883283171013218, 3.9153735189295524],
  [-12.483283552482945, 9.115372374520373],
  [-7.983283552482945, -3.2846272440099007],
  [-10.983283552482945, 6.015373900399279],
  [-6.283282789543492, -10.384627625479627],
  [-8.783282789543492, -2.2846272440099007],
  [-9.083283933952671, -1.6846268625401741],
  [-8.283282789543492, -4.084626481070448],
  [-7.083283933952671, -6.184626862540174],
  [-5.783282789543492, -10.284625336661268],
  [-8.183284315422398, -2.484626099600721],
  [-7.683284315422398, -4.184626862540174],
  [-6.483283552482945, -9.58462838841908],
  [-9.283283743217808, 0.8153731374598259],
  [-5.583283933952671, -10.984626099600721],
  [-8.783282789543492, -0.6846268625401741],
  [-8.083283933952671, -4.784627244009901],
  [-8.683284315422398, -2.8846276254796273],
  [-9.283283743217808, -1.0846264810704476],
  [-10.683283361748082, 3.2153727559900993],
  [-6.083283933952671, -11.284625336661268],
  [-7.283282789543492, -5.584626481070448],
  [-5.983283552482945, -9.58462838841908],
  [-11.183283361748082, 4.715372755990099],
  [-7.483283552482945, -4.984626099600721],
  [-9.783283743217808, 2.4153735189295524],
  [-12.383283171013218, 8.415373518929552],
  [-8.483283552482945, -3.5846264810704476],
  [-9.783283743217808, 0.41537351892955243],
  [-11.683283361748082, 8.315373137459826],
  [-6.783282789543492, -8.884627625479627],
  [-10.283283743217808, 3.9153735189295524],
  [-7.883283171013218, -5.584626481070448],
  [-7.583283933952671, -6.484626099600721],
  [-9.483283552482945, -0.38462762547962726],
  [-9.983283552482945, 1.1153723745203727],
  [-6.883283171013218, -6.884627625479627],
  [-10.383283171013218, 2.515373900399279],
  [-9.583283933952671, 1.6153723745203727],
  [-11.883283171013218, 7.015373900399279],
  [-10.183283361748082, 1.8153731374598259],
  [-5.283282789543492, -11.684626862540174],
  [-10.783283743217808, 5.315373137459826],
  [-6.183284315422398, -8.884627625479627],
  [-10.083283933952671, 3.2153727559900993],
  [-10.583283933952671, 4.715372755990099],
  [-5.783282789543492, -11.984626099600721],
  [-4.983283552482945, -12.384627625479627],
  [-5.483283552482945, -12.784625336661268],
  [-4.783282789543492, -13.08462838841908],
  [-5.283282789543492, -13.484626099600721],
  [-7.283282789543492, -7.384627625479627],
  [-6.483283552482945, -8.184626862540174],
  [-6.683284315422398, -7.484626099600721],
  [-11.183283361748082, 6.715372755990099],
  [-11.983283552482945, 9.115372374520373],
  [-11.483283552482945, 5.515373900399279],
  [-6.983283552482945, -8.08462838841908],
  [-11.483283552482945, 7.515373900399279],
  [-11.683283361748082, 6.315373137459826],
  [-12.083283933952671, 7.715372755990099],
  [5.516716447517055, -1.484626099600721],
  [8.116714921638149, -1.1846268625401741],
  [10.016716447517055, -0.38462762547962726],
  [10.416717973395961, -0.08462648107044757],
  [4.916716066047329, -1.3846276254796273],
  [6.616716828986782, -1.484626099600721],
  [11.416717973395961, 1.015373900399279],
  [7.116714921638149, -1.3846276254796273],
  [8.616714921638149, -0.984626099600721],
  [10.816715684577602, 0.2153727559900993],
  [11.116714921638149, 0.515373900399279],
  [9.116714921638149, -0.7846272440099007],
  [9.616714921638149, -0.5846264810704476],
  [4.516716447517055, -1.1846268625401741],
  [6.016716447517055, -1.484626099600721],
  [7.616714921638149, -1.2846272440099007],
  [11.216717210456508, 2.4153735189295524],
  [8.816715684577602, 9.915373518929552],
  [9.916717973395961, 6.615372374520373],
  [9.416717973395961, 8.015373900399279],
  [9.716717210456508, 7.015373900399279],
  [9.616714921638149, 7.515373900399279],
  [8.216717210456508, 11.815373137459826],
  [8.516716447517055, 10.815373137459826],
  [10.316715684577602, 5.215372755990099],
  [11.416717973395961, 1.9153735189295524],
  [8.316715684577602, 11.315373137459826],
  [9.316715684577602, 8.415373518929552],
  [8.016716447517055, 12.315373137459826],
  [10.516716447517055, 4.715372755990099],
  [11.116714921638149, 2.815373137459826],
  [10.216717210456508, 5.615372374520373],
  [10.916717973395961, 3.315373137459826],
  [9.016716447517055, 9.415373518929552],
  [9.116714921638149, 8.915373518929552],
  [8.616714921638149, 10.415373518929552],
  [7.916717973395961, 12.7153727559901],
  [10.816715684577602, 3.815373137459826],
  [11.516716447517055, 1.4153735189295524],
  [10.016716447517055, 6.115372374520373],
  [10.616714921638149, 4.215372755990099],
  [7.416717973395961, 12.915373518929552],
  [4.716717210456508, 11.015372946724963],
  [7.116714921638149, 12.515372946724963],
  [5.116716828986782, 11.2153727559901],
  [4.116716828986782, 10.815373137459826],
  [5.916716066047329, 11.61537332819469],
  [6.316715684577602, 11.915373518929552],
  [6.716717210456508, 12.2153727559901],
  [7.616714921638149, 13.315373137459826],
  [5.516716447517055, 11.415373518929552],
  [4.016716447517055, -0.38462762547962726],
  [3.6167168289867817, 0.7153727559900993],
  [3.816715684577602, 0.2153727559900993],
  [3.516716447517055, 1.3153731374598259],
  [4.516716447517055, -0.2846272440099007],
  [6.416716066047329, 1.4153735189295524],
  [5.316715684577602, 0.31537313745982587],
  [5.816715684577602, 0.6153723745203727],
  [6.216717210456508, 0.9153735189295524],
  [4.316715684577602, -0.7846272440099007],
  [4.916716066047329, 0.11537237452037274],
  [4.716717210456508, 2.1153723745203727],
  [5.316715684577602, 2.2153727559900993],
  [3.6167168289867817, 1.8153731374598259],
  [5.816715684577602, 2.2153727559900993],
  [6.316715684577602, 1.9153735189295524],
  [4.116716828986782, 2.015373900399279],
  [7.716717210456508, 11.61537332819469],
  [7.816715684577602, 11.015372946724963],
  [7.116714921638149, 11.815373137459826],
  [6.716717210456508, 10.115372374520373],
  [7.116714921638149, 11.2153727559901],
  [5.816715684577602, 10.915373518929552],
  [6.516716447517055, 10.7153727559901],
  [5.616716828986782, 10.415373518929552],
  [6.516716447517055, 11.315373137459826],
  [4.816715684577602, 9.315373137459826],
  [5.916716066047329, 9.7153727559901],
  [5.016716447517055, 10.415373518929552],
  [4.216717210456508, 10.115372374520373],
  [7.316715684577602, 10.515372946724963],
  [7.516716447517055, 12.315373137459826],
  [7.016716447517055, 7.815373137459826],
  [6.316715684577602, 8.915373518929552],
  [6.116716828986782, 8.315373137459826],
  [7.116714921638149, 8.515373900399279],
  [7.416717973395961, 9.415373518929552],
  [7.816715684577602, 9.815373137459826],
  [7.916717973395961, 8.415373518929552],
  [8.416717973395961, 9.615372374520373],
  [6.916716066047329, 9.115372374520373],
  [5.816715684577602, 7.415373518929552],
  [5.316715684577602, 8.415373518929552],
  [4.916716066047329, 7.715372755990099],
  [8.416717973395961, 9.015373900399279],
  [8.116714921638149, 10.415373518929552],
  [7.816715684577602, 9.015373900399279],
  [9.016716447517055, 7.015373900399279],
  [9.016716447517055, 7.615372374520373],
  [8.416717973395961, 7.215372755990099],
  [5.516716447517055, 6.215372755990099],
  [6.316715684577602, 6.515373900399279],
  [8.516716447517055, 6.515373900399279],
  [7.916717973395961, 6.715372755990099],
  [7.416717973395961, 7.115372374520373],
  [6.916716066047329, 6.715372755990099],
  [7.816715684577602, 6.015373900399279],
  [7.916717973395961, 7.415373518929552],
  [7.016716447517055, 5.815373137459826],
  [6.016716447517055, 5.415373518929552],
  [8.416717973395961, 7.915373518929552],
  [8.816715684577602, 8.415373518929552],
  [8.716717210456508, 4.915373518929552],
  [9.316715684577602, 4.615372374520373],
  [8.216717210456508, 5.315373137459826],
  [9.416717973395961, 6.415373518929552],
  [7.516716447517055, 4.915373518929552],
  [6.616716828986782, 3.4153735189295524],
  [9.516716447517055, 5.815373137459826],
  [9.216717210456508, 5.315373137459826],
  [9.716717210456508, 5.215372755990099],
  [6.116716828986782, 4.315373137459826],
  [7.616714921638149, 3.7153727559900993],
  [8.016716447517055, 4.615372374520373],
  [8.816715684577602, 5.815373137459826],
  [8.616714921638149, 4.015373900399279],
  [6.916716066047329, 4.515373900399279],
  [7.716717210456508, 2.815373137459826],
  [6.816715684577602, 1.2153727559900993],
  [9.116714921638149, 2.1153723745203727],
  [9.816715684577602, 2.515373900399279],
  [9.716717210456508, 3.9153735189295524],
  [7.516716447517055, 2.1153723745203727],
  [10.316715684577602, 3.1153723745203727],
  [8.316715684577602, 2.515373900399279],
  [9.216717210456508, 3.515373900399279],
  [10.316715684577602, 3.7153727559900993],
  [8.516716447517055, 3.2153727559900993],
  [6.716717210456508, 2.315373137459826],
  [8.216717210456508, 1.6153723745203727],
  [9.116714921638149, 2.815373137459826],
  [10.116714921638149, 4.415373518929552],
  [9.616714921638149, 3.2153727559900993],
  [9.316715684577602, -0.18462686254017413],
  [8.316715684577602, 0.7153727559900993],
  [9.916717973395961, 1.7153727559900993],
  [9.016716447517055, 1.015373900399279],
  [8.716717210456508, 0.2153727559900993],
  [8.216717210456508, -0.484626099600721],
  [9.516716447517055, 0.515373900399279],
  [10.016716447517055, 0.9153735189295524],
  [9.516716447517055, 1.2153727559900993],
  [10.516716447517055, 1.4153735189295524],
  [6.116716828986782, 0.11537237452037274],
  [10.216717210456508, 0.31537313745982587],
  [5.016716447517055, -0.484626099600721],
  [7.116714921638149, -0.6846268625401741],
  [10.516716447517055, 2.015373900399279],
  [7.016716447517055, 0.2153727559900993],
  [10.716717210456508, 2.515373900399279],
  [11.016716447517055, 1.515373900399279],
  [10.816715684577602, 0.9153735189295524],
  [7.716717210456508, 0.31537313745982587],
  [5.916716066047329, -0.8846276254796273],
  [-2.0832839339526714, 10.915373518929552],
  [-1.5832839339526714, 11.2153727559901],
  [0.316715684577602, 12.7153727559901],
  [-3.683284315422398, 10.015373900399279],
  [-0.7832827895434917, 12.915373518929552],
  [-10.083283933952671, 8.115372374520373],
  [1.6167168289867817, 12.915373518929552],
  [-6.883283171013218, 8.315373137459826],
  [0.016716447517055144, 11.915373518929552],
  [-2.2832827895434917, 12.2153727559901],
  [-10.783283743217808, 8.015373900399279],
  [-8.483283552482945, 8.115372374520373],
  [0.316715684577602, 13.315373137459826],
  [1.5167164475170551, 13.61537332819469],
  [-1.683284315422398, 12.515372946724963],
  [-6.883283171013218, 9.7153727559901],
  [-4.783282789543492, 9.415373518929552],
  [-4.283282789543492, 9.7153727559901],
  [-6.083283933952671, 8.7153727559901],
  [-8.883283171013218, 7.515373900399279],
  [-2.2832827895434917, 11.515372946724963],
  [-0.8832831710132183, 12.015372946724963],
  [-9.683283361748082, 7.315373137459826],
  [-1.0832839339526714, 11.415373518929552],
  [2.316715684577602, 12.915373518929552],
  [-6.883283171013218, 9.015373900399279],
  [2.4167160660473286, 12.315373137459826],
  [-3.5832839339526714, 11.515372946724963],
  [-3.683284315422398, 10.815373137459826],
  [-2.8832831710132183, 11.915373518929552],
  [-6.183284315422398, 9.315373137459826],
  [-4.183284315422398, 11.11537332819469],
  [-2.7832827895434917, 11.315373137459826],
  [-1.183284315422398, 12.61537332819469],
  [-0.28328278954349173, 12.415373518929552],
  [-4.783282789543492, 10.815373137459826],
  [-0.18328431542239798, 13.11537332819469],
  [-5.483283552482945, 10.415373518929552],
  [-3.183284315422398, 10.915373518929552],
  [2.1167168289867817, 13.515372946724963],
  [1.6167168289867817, 12.315373137459826],
  [-9.383283171013218, 8.415373518929552],
  [-5.383283171013218, 9.115372374520373],
  [-8.583283933952671, 8.915373518929552],
  [-7.683284315422398, 8.615372374520373],
  [1.0167164475170551, 12.315373137459826],
  [1.0167164475170551, 12.915373518929552],
  [-4.183284315422398, 10.415373518929552],
  [0.5167164475170551, 12.11537332819469],
  [-5.583283933952671, 9.7153727559901],
  [-1.5832839339526714, 11.915373518929552],
  [0.9167160660473286, 13.515372946724963],
  [-10.483283552482945, 7.115372374520373],
  [-7.783282789543492, 7.915373518929552],
  [-2.5832839339526714, 10.61537332819469],
  [-4.883283171013218, 10.115372374520373],
  [-3.183284315422398, 10.315373137459826],
  [-0.5832839339526714, 11.61537332819469],
  [-7.683284315422398, 9.315373137459826],
  [-6.183284315422398, 10.115372374520373],
  [-3.5832839339526714, 8.515373900399279],
  [-7.283282789543492, 6.415373518929552],
  [-4.083283933952671, 8.2153727559901],
  [0.1167168289867817, 10.315373137459826],
  [-7.583283933952671, 5.815373137459826],
  [-7.883283171013218, 6.915373518929552],
  [-0.8832831710132183, 9.2153727559901],
  [0.9167160660473286, 9.915373518929552],
  [1.6167168289867817, 10.315373137459826],
  [0.9167160660473286, 10.515372946724963],
  [-3.483283552482945, 7.815373137459826],
  [-0.5832839339526714, 10.815373137459826],
  [-5.383283171013218, 7.815373137459826],
  [-0.9832835524829449, 9.915373518929552],
  [-10.183283361748082, 6.115372374520373],
  [-1.183284315422398, 10.515372946724963],
  [-4.683284315422398, 7.815373137459826],
  [-3.683284315422398, 9.115372374520373],
  [-1.3832831710132183, 9.015373900399279],
  [-6.583283933952671, 7.315373137459826],
  [0.016716447517055144, 11.015372946724963],
  [-7.183284315422398, 7.215372755990099],
  [2.516716447517055, 11.61537332819469],
  [-2.983283552482945, 8.115372374520373],
  [-1.9832835524829449, 9.415373518929552],
  [0.7167172104565083, 11.315373137459826],
  [-1.8832831710132183, 8.7153727559901],
  [0.21671721045650827, 9.7153727559901],
  [2.6167168289867817, 10.7153727559901],
  [3.1167168289867817, 10.415373518929552],
  [-2.983283552482945, 8.7153727559901],
  [-3.0832839339526714, 9.515373900399279],
  [-9.183283361748082, 5.315373137459826],
  [-4.383283171013218, 8.815373137459826],
  [-1.4832835524829449, 9.615372374520373],
  [-1.7832827895434917, 10.2153727559901],
  [0.5167164475170551, 10.815373137459826],
  [-2.5832839339526714, 9.115372374520373],
  [-5.283282789543492, 6.915373518929552],
  [-8.483283552482945, 6.415373518929552],
  [-9.283283743217808, 6.315373137459826],
  [-0.3832831710132183, 9.515373900399279],
  [-2.3832831710132183, 9.915373518929552],
  [-4.083283933952671, 7.515373900399279],
  [-5.083283933952671, 8.415373518929552],
  [2.2167172104565083, 10.415373518929552],
  [-8.483283552482945, 5.515373900399279],
  [-9.883283171013218, 5.215372755990099],
  [1.316715684577602, 10.915373518929552],
  [-6.083283933952671, 7.915373518929552],
  [2.016716447517055, 11.015372946724963],
  [1.316715684577602, 11.515372946724963],
  [-2.3832831710132183, 8.415373518929552],
  [-0.48328355248294486, 10.2153727559901],
  [-4.683284315422398, 7.215372755990099],
  [-5.783282789543492, 7.215372755990099],
  [-6.683284315422398, 6.215372755990099],
  [1.9167160660473286, 11.61537332819469],
  [2.9167160660473286, 11.2153727559901],
  [-5.983283552482945, 6.515373900399279],
  [1.9167160660473286, 8.115372374520373],
  [-2.683284315422398, 7.415373518929552],
  [-2.183284315422398, 7.015373900399279],
  [-1.683284315422398, 7.215372755990099],
  [0.9167160660473286, 9.315373137459826],
  [-1.9832835524829449, 7.815373137459826],
  [0.4167160660473286, 8.915373518929552],
  [1.4167160660473286, 8.315373137459826],
  [-7.483283552482945, 4.015373900399279],
  [-3.0832839339526714, 6.315373137459826],
  [-2.8832831710132183, 5.815373137459826],
  [-9.283283743217808, 3.1153723745203727],
  [-3.8832831710132183, 6.615372374520373],
  [2.9167160660473286, 9.115372374520373],
  [-4.283282789543492, 5.715372755990099],
  [-5.883283171013218, 5.115372374520373],
  [1.7167172104565083, 9.515373900399279],
  [-2.2832827895434917, 6.215372755990099],
  [-4.383283171013218, 5.015373900399279],
  [-1.2832827895434917, 7.715372755990099],
  [3.816715684577602, 8.515373900399279],
  [-7.683284315422398, 4.815373137459826],
  [-3.683284315422398, 5.415373518929552],
  [-2.683284315422398, 6.815373137459826],
  [-1.183284315422398, 6.715372755990099],
  [-1.2832827895434917, 8.2153727559901],
  [-3.5832839339526714, 6.015373900399279],
  [0.316715684577602, 7.515373900399279],
  [2.4167160660473286, 9.115372374520373],
  [2.6167168289867817, 8.415373518929552],
  [-1.7832827895434917, 6.415373518929552],
  [2.016716447517055, 8.7153727559901],
  [-0.08328393395267142, 8.7153727559901],
  [-6.883283171013218, 4.715372755990099],
  [-3.3832831710132183, 7.015373900399279],
  [-6.583283933952671, 5.415373518929552],
  [-0.683284315422398, 8.515373900399279],
  [-4.383283171013218, 6.415373518929552],
  [-0.8832831710132183, 7.215372755990099],
  [3.1167168289867817, 9.7153727559901],
  [2.4167160660473286, 9.7153727559901],
  [3.2167172104565083, 8.615372374520373],
  [-0.5832839339526714, 7.915373518929552],
  [-7.983283552482945, 3.4153735189295524],
  [-9.483283552482945, 4.215372755990099],
  [-8.483283552482945, 4.515373900399279],
  [1.1167168289867817, 7.815373137459826],
  [-4.983283552482945, 6.015373900399279],
  [-0.28328278954349173, 7.215372755990099],
  [-6.083283933952671, 4.415373518929552],
  [-4.983283552482945, 5.215372755990099],
  [1.4167160660473286, 9.015373900399279],
  [-5.583283933952671, 5.815373137459826],
  [-0.08328393395267142, 8.015373900399279],
  [-5.283282789543492, 4.615372374520373],
  [-6.683284315422398, 3.9153735189295524],
  [0.9167160660473286, 8.515373900399279],
  [-8.783282789543492, 3.7153727559900993],
  [3.516716447517055, 9.315373137459826],
  [0.5167164475170551, 8.015373900399279],
  [-5.383283171013218, 3.7153727559900993],
  [-3.0832839339526714, 4.115372374520373],
  [3.1167168289867817, 6.515373900399279],
  [2.6167168289867817, 7.015373900399279],
  [-1.2832827895434917, 5.715372755990099],
  [-6.283282789543492, 3.2153727559900993],
  [3.7167172104565083, 6.615372374520373],
  [-3.8832831710132183, 3.1153723745203727],
  [1.4167160660473286, 6.515373900399279],
  [3.316715684577602, 7.215372755990099],
  [2.6167168289867817, 6.315373137459826],
  [-6.983283552482945, 2.815373137459826],
  [0.5167164475170551, 5.915373518929552],
  [-7.483283552482945, 2.015373900399279],
  [1.5167164475170551, 5.815373137459826],
  [-4.383283171013218, 4.215372755990099],
  [-7.983283552482945, 2.515373900399279],
  [0.016716447517055144, 5.615372374520373],
  [2.816715684577602, 7.715372755990099],
  [-2.3832831710132183, 5.315373137459826],
  [-3.0832839339526714, 4.915373518929552],
  [2.2167172104565083, 7.515373900399279],
  [-0.5832839339526714, 4.815373137459826],
  [4.316715684577602, 6.515373900399279],
  [-6.783282789543492, 1.6153723745203727],
  [2.1167168289867817, 6.115372374520373],
  [-1.7832827895434917, 5.615372374520373],
  [1.0167164475170551, 6.115372374520373],
  [-3.7832827895434917, 3.815373137459826],
  [2.016716447517055, 6.815373137459826],
  [-4.983283552482945, 2.515373900399279],
  [0.1167168289867817, 5.115372374520373],
  [-4.483283552482945, 2.9153735189295524],
  [-8.883283171013218, 2.2153727559900993],
  [-5.483283552482945, 3.1153723745203727],
  [-8.683284315422398, 1.3153731374598259],
  [-0.8832831710132183, 6.115372374520373],
  [-3.683284315422398, 4.515373900399279],
  [3.4167160660473286, 7.815373137459826],
  [-1.2832827895434917, 5.115372374520373],
  [0.816715684577602, 5.415373518929552],
  [-2.5832839339526714, 3.7153727559900993],
  [-3.183284315422398, 3.4153735189295524],
  [-1.683284315422398, 4.215372755990099],
  [1.0167164475170551, 7.015373900399279],
  [4.116716828986782, 7.115372374520373],
  [0.5167164475170551, 6.715372755990099],
  [-4.683284315422398, 3.6153723745203727],
  [-0.3832831710132183, 6.215372755990099],
  [-7.983283552482945, 1.3153731374598259],
  [0.016716447517055144, 6.515373900399279],
  [-6.283282789543492, 2.2153727559900993],
  [-0.5832839339526714, 5.415373518929552],
  [4.016716447517055, 7.615372374520373],
  [1.6167168289867817, 7.315373137459826],
  [-5.683284315422398, 2.2153727559900993],
  [-2.5832839339526714, 4.715372755990099],
  [-1.0832839339526714, 4.515373900399279],
  [-1.8832831710132183, 4.915373518929552],
  [-2.183284315422398, 4.215372755990099],
  [5.016716447517055, 4.615372374520373],
  [-3.3832831710132183, 1.7153727559900993],
  [-0.28328278954349173, 4.015373900399279],
  [-6.683284315422398, -0.484626099600721],
  [4.016716447517055, 5.315373137459826],
  [-7.283282789543492, 0.515373900399279],
  [3.7167172104565083, 4.615372374520373],
  [-6.383283171013218, 0.2153727559900993],
  [-2.8832831710132183, 1.3153731374598259],
  [-5.383283171013218, 0.6153723745203727],
  [-4.183284315422398, 1.7153727559900993],
  [1.2167172104565083, 3.9153735189295524],
  [0.4167160660473286, 3.7153727559900993],
  [-0.5832839339526714, 3.515373900399279],
  [0.816715684577602, 4.715372755990099],
  [-5.583283933952671, -0.08462648107044757],
  [3.316715684577602, 5.215372755990099],
  [-1.683284315422398, 1.9153735189295524],
  [2.7167172104565083, 5.615372374520373],
  [-0.9832835524829449, 3.815373137459826],
  [-1.0832839339526714, 2.2153727559900993],
  [4.716717210456508, 5.115372374520373],
  [-7.483283552482945, -0.38462762547962726],
  [-5.483283552482945, 1.3153731374598259],
  [3.4167160660473286, 5.715372755990099],
  [-0.28328278954349173, 2.6153723745203727],
  [-1.3832831710132183, 2.815373137459826],
  [-4.783282789543492, 1.515373900399279],
  [1.1167168289867817, 3.315373137459826],
  [0.1167168289867817, 4.315373137459826],
  [-6.383283171013218, 1.015373900399279],
  [-1.9832835524829449, 3.1153723745203727],
  [1.5167164475170551, 5.015373900399279],
  [-3.7832827895434917, 2.2153727559900993],
  [2.1167168289867817, 4.715372755990099],
  [-8.183284315422398, 0.31537313745982587],
  [1.5167164475170551, 4.415373518929552],
  [-2.2832827895434917, 1.6153723745203727],
  [-2.5832839339526714, 2.1153723745203727],
  [-3.183284315422398, 2.515373900399279],
  [2.016716447517055, 5.315373137459826],
  [4.316715684577602, 4.615372374520373],
  [2.816715684577602, 4.215372755990099],
  [0.4167160660473286, 3.015373900399279],
  [2.2167172104565083, 4.015373900399279],
  [1.816715684577602, 3.7153727559900993],
  [2.7167172104565083, 4.915373518929552],
  [-4.183284315422398, 0.9153735189295524],
  [4.616716828986782, 5.715372755990099],
  [3.316715684577602, 4.415373518929552],
  [-8.083283933952671, -0.6846268625401741],
  [-1.4832835524829449, 3.4153735189295524],
  [-3.5832839339526714, 0.9153735189295524],
  [0.7167172104565083, 4.215372755990099],
  [-0.08328393395267142, 3.2153727559900993],
  [-0.7832827895434917, 2.9153735189295524],
  [-2.5832839339526714, 2.815373137459826],
  [-1.8832831710132183, 2.4153735189295524],
  [4.016716447517055, 5.915373518929552],
  [-4.583283933952671, 0.41537351892955243],
  [4.416716066047329, 1.4153735189295524],
  [4.616716828986782, 0.6153723745203727],
  [5.416716066047329, 1.4153735189295524],
  [-0.683284315422398, 1.515373900399279],
  [1.4167160660473286, 1.3153731374598259],
  [1.7167172104565083, 1.8153731374598259],
  [-0.8832831710132183, 0.515373900399279],
  [-0.3832831710132183, 0.9153735189295524],
  [-2.483283552482945, -0.6846268625401741],
  [-4.183284315422398, -0.8846276254796273],
  [-2.8832831710132183, -0.18462686254017413],
  [4.016716447517055, 3.815373137459826],
  [-0.28328278954349173, 0.31537313745982587],
  [4.416716066047329, 2.6153723745203727],
  [-3.8832831710132183, -0.08462648107044757],
  [0.7167172104565083, 1.6153723745203727],
  [0.1167168289867817, 1.3153731374598259],
  [-5.383283171013218, -0.984626099600721],
  [2.4167160660473286, 2.7153727559900993],
  [-1.4832835524829449, 0.41537351892955243],
  [-5.883283171013218, -2.184626862540174],
  [1.2167172104565083, 2.1153723745203727],
  [-3.8832831710132183, -1.484626099600721],
  [-1.683284315422398, 1.015373900399279],
  [3.516716447517055, 2.9153735189295524],
  [1.816715684577602, 2.515373900399279],
  [-2.2832827895434917, 0.7153727559900993],
  [3.1167168289867817, 2.1153723745203727],
  [-6.083283933952671, -1.1846268625401741],
  [5.616716828986782, 2.6153723745203727],
  [3.516716447517055, 3.6153723745203727],
  [-1.183284315422398, 1.2153727559900993],
  [0.316715684577602, 0.7153727559900993],
  [-1.7832827895434917, -0.38462762547962726],
  [-2.983283552482945, 0.41537351892955243],
  [-2.0832839339526714, 0.11537237452037274],
  [-3.483283552482945, -0.5846264810704476],
  [-6.683284315422398, -2.3846276254796273],
  [2.9167160660473286, 3.4153735189295524],
  [0.816715684577602, 1.015373900399279],
  [-1.0832839339526714, -0.08462648107044757],
  [-4.783282789543492, -0.484626099600721],
  [2.516716447517055, 2.1153723745203727],
  [-0.28328278954349173, 1.8153731374598259],
  [2.2167172104565083, 1.6153723745203727],
  [1.4167160660473286, 2.815373137459826],
  [5.416716066047329, 3.2153727559900993],
  [0.21671721045650827, 2.015373900399279],
  [-6.883283171013218, -1.484626099600721],
  [-7.383283171013218, -2.684626862540174],
  [-5.183284315422398, -1.8846276254796273],
  [3.816715684577602, 2.315373137459826],
  [0.7167172104565083, 2.4153735189295524],
  [2.2167172104565083, 3.2153727559900993],
  [5.016716447517055, 2.7153727559900993],
  [-3.0832839339526714, -1.0846264810704476],
  [4.016716447517055, 3.1153723745203727],
  [-4.583283933952671, -1.5846264810704476],
  [4.616716828986782, 3.9153735189295524],
  [4.616716828986782, 3.315373137459826],
  [-7.683284315422398, -1.7846272440099007],
  [5.216717210456508, 3.7153727559900993],
  [3.016716447517055, 2.815373137459826],
  [-0.8832831710132183, -0.484626099600721],
  [-4.283282789543492, -2.2846272440099007],
  [2.2167172104565083, 1.1153723745203727],
  [1.816715684577602, 0.9153735189295524],
  [-1.683284315422398, -0.984626099600721],
  [-6.583283933952671, -3.184626862540174],
  [-3.8832831710132183, -2.0846264810704476],
  [-2.0832839339526714, -1.1846268625401741],
  [-1.2832827895434917, -0.7846272440099007],
  [-2.5832839339526714, -1.3846276254796273],
  [-0.3832831710132183, -0.2846272440099007],
  [-2.983283552482945, -1.6846268625401741],
  [-7.083283933952671, -3.2846272440099007],
  [-3.3832831710132183, -1.8846276254796273],
  [0.016716447517055144, 0.015373900399278995],
  [0.5167164475170551, 0.2153727559900993],
  [-4.683284315422398, -2.484626099600721],
  [0.9167160660473286, 0.41537351892955243],
  [-5.183284315422398, -2.684626862540174],
  [1.316715684577602, 0.7153727559900993],
  [2.7167172104565083, 1.3153731374598259],
  [-6.183284315422398, -2.984626099600721],
  [-5.683284315422398, -2.8846276254796273],
  [3.1167168289867817, 1.515373900399279],
  [-3.8832831710132183, 12.015372946724963],
  [-2.183284315422398, 12.915373518929552],
  [2.4167160660473286, 13.915373518929552],
  [-2.683284315422398, 12.61537332819469],
  [-8.283282789543492, 9.7153727559901],
  [-10.983283552482945, 8.7153727559901],
  [0.5167164475170551, 14.015372946724963],
  [-4.383283171013218, 11.7153727559901],
  [-9.083283933952671, 9.315373137459826],
  [-3.0832839339526714, 12.415373518929552],
  [-7.383283171013218, 10.2153727559901],
  [2.016716447517055, 14.2153727559901],
  [0.016716447517055144, 13.915373518929552],
  [-8.683284315422398, 9.515373900399279],
  [-7.783282789543492, 9.915373518929552],
  [-4.783282789543492, 11.515372946724963],
  [-6.883283171013218, 10.415373518929552],
  [-1.7832827895434917, 13.11537332819469],
  [-6.483283552482945, 10.61537332819469],
  [-3.483283552482945, 12.2153727559901],
  [-5.183284315422398, 11.315373137459826],
  [1.0167164475170551, 14.2153727559901],
  [-9.983283552482945, 9.015373900399279],
  [-9.583283933952671, 9.2153727559901],
  [-6.083283933952671, 10.815373137459826],
  [-0.8832831710132183, 13.515372946724963],
  [1.5167164475170551, 14.2153727559901],
  [-0.3832831710132183, 13.7153727559901],
  [-5.583283933952671, 11.11537332819469],
  [-10.483283552482945, 8.815373137459826],
  [-1.2832827895434917, 13.315373137459826],
  [5.316715684577602, 5.215372755990099],
  [3.016716447517055, 12.11537332819469],
  [4.316715684577602, 8.2153727559901],
  [4.516716447517055, 7.715372755990099],
  [4.616716828986782, 7.215372755990099],
  [3.7167172104565083, 10.2153727559901],
  [3.2167172104565083, 11.61537332819469],
  [3.816715684577602, 9.7153727559901],
  [2.9167160660473286, 12.61537332819469],
  [5.916716066047329, 3.315373137459826],
  [6.016716447517055, 2.9153735189295524],
  [4.916716066047329, 6.215372755990099],
  [3.516716447517055, 10.7153727559901],
  [4.816715684577602, 6.715372755990099],
  [3.316715684577602, 11.2153727559901],
  [5.716717210456508, 3.815373137459826],
  [4.216717210456508, 8.7153727559901],
  [5.116716828986782, 5.715372755990099],
  [4.016716447517055, 9.2153727559901],
  [2.7167172104565083, 13.11537332819469],
  [2.6167168289867817, 13.515372946724963],
  [5.416716066047329, 4.815373137459826],
  [6.216717210456508, 2.4153735189295524],
  [5.616716828986782, 4.315373137459826],
];
